import Swiper from "swiper/bundle";

const BrandsSlider = () => {
  const brandsSliders = [...document.querySelectorAll(".hero__brands-slider")];

  if (brandsSliders.length > 0) {
    const isRTL = document.documentElement.dir === 'rtl';
    brandsSliders.forEach((brandsSlider) => {
      const swiper = new Swiper(brandsSlider, {
        slidesPerView: "auto",
        loop: true,
        centeredSlides: true,
        rtl: isRTL,
        autoplay: {
          delay: 0, 
          disableOnInteraction: false, 
        },
        speed: 2500,
        spaceBetween: 32,
        breakpoints: {
          768: {
            spaceBetween: 48,
          },
        }
      });
    });
  };
};

export default BrandsSlider;
